export default __webpack_public_path__ + "static/media/topcap.ccfafefd.svg";